import { snacksTypes } from "./snacksTypes"; 

export const burgerTypeIncrease = () => {
    return {
        type : snacksTypes.BURGER_TYPE_INCREASE,
        payload : 150
    }
}

export const burgerTypeDecrease = () => {
    return {
        type : snacksTypes.BURGER_TYPE_DECREASE,
        payload : 150
    }
}

export const friesTypeIncrease = () => {
    return {
        type : snacksTypes.FRIES_TYPE_INCREASE,
        payload : 75
    }
}

export const friesTypeDecrease = () => {
    return {
        type : snacksTypes.FRIES_TYPE_DECREASE,
        payload : 75
    }
}

export const wrapTypeIncrease = () => {
    return {
        type : snacksTypes.WRAP_TYPE_INCREASE,
        payload : 125
    }
}

export const wrapTypeDecrease = () => {
    return {
        type : snacksTypes.WRAP_TYPE_DECREASE,
        payload : 125
    }
}

export const pizzaTypeIncrease = () => {
    return {
        type : snacksTypes.PIZZA_TYPE_INCREASE,
        payload : 180
    }
}

export const pizzaTypeDecrease = () => {
    return {
        type : snacksTypes.PIZZA_TYPE_DECREASE,
        payload : 180
    }
}

export const clearAllSnacks = () => {
    return { type : snacksTypes.CLEAR_ALL_SNACKS }
}